import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import vSelect from 'vue-select';

export default Vue.component('edit-project-feed', {
  template: require('./template.html'),
  name: 'edit-project-feed',
  props: ['droplet', 'show-edit-bubble'],
  components: {
    vSelect,
  },
  computed: {
    ...mapGetters(['currentSite']),
    dynamicEnabled() {
      return this.currentSite.dynamic && this.currentSite.dynamic.serviceCompany;
    },
    categoryOptions() {
      let list = [];
      if (this.dynamicEnabled) {
        list = this.dynamicEnabled.categories;
      }
      return list;
    },
  },
  data() {
    return {
      display: {
        filters: null,
        sortKey: false,
      },
    };
  },
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValues();
      }
    },
  },
  methods: {
    setInitialValues() {
      this.display.filters = _.clone(this.droplet.filters);
      this.display.sortKey = this.droplet.sortKey;
    },
    selectCategory(list) {
      if (list) {
        const val = _.clone(list);
        this.$store.dispatch('setDropletVal', {
          drp: this.droplet,
          key: 'filters',
          val,
        });
      }
    },
    radioUpdate(val, key) {
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        key,
        val,
      });
    },
    updateSortKey() {
      const val = this.display.sortKey ? 'projectDate.date' : false;
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        val,
        key: 'sortKey',
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/project-feed/components/_edit-options/index.js